import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import FilterListIcon from '@mui/icons-material/FilterList';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { CourseMappingColumn } from '../../interfaces/CourseMappingInterface';
import { CourseMappingSortOrder, CourseMappingSortState } from './courseMappingSort';

interface CourseMappingColumnMenuProps {
  column: CourseMappingColumn;
  anchorEl: HTMLElement | null;
  open: boolean;
  sort: CourseMappingSortState | null;
  onClose: () => void;
  onSort: (order: CourseMappingSortOrder | null) => void;
  onFilter: () => void;
  onHide: () => void;
}

const CourseMappingColumnMenu = ({
  column,
  anchorEl,
  open,
  sort,
  onClose,
  onSort,
  onFilter,
  onHide,
}: CourseMappingColumnMenuProps) => {
  const isSortedBy = sort?.key === column.key;

  const handleSort = (order: CourseMappingSortOrder) => {
    const isActive = isSortedBy && sort?.order === order;
    onSort(isActive ? null : order);
    onClose();
  };

  const handleFilter = () => {
    onFilter();
    onClose();
  };

  const handleHide = () => {
    onHide();
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      className="course-mapping-column-menu"
      PaperProps={{ className: 'course-mapping-dropdown-menu-paper' }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MenuItem
        className={`course-mapping-column-menu-item${
          isSortedBy && sort?.order === 'asc' ? ' course-mapping-column-menu-item--active' : ''
        }`}
        onClick={() => handleSort('asc')}
      >
        <ListItemIcon>
          <ArrowDownwardIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Sort A &rarr; Z</ListItemText>
      </MenuItem>
      <MenuItem
        className={`course-mapping-column-menu-item${
          isSortedBy && sort?.order === 'desc' ? ' course-mapping-column-menu-item--active' : ''
        }`}
        onClick={() => handleSort('desc')}
      >
        <ListItemIcon>
          <ArrowUpwardIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Sort Z &rarr; A</ListItemText>
      </MenuItem>
      <MenuItem className="course-mapping-column-menu-item" onClick={handleFilter}>
        <ListItemIcon>
          <FilterListIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Filter</ListItemText>
      </MenuItem>
      <MenuItem className="course-mapping-column-menu-item" onClick={handleHide}>
        <ListItemIcon>
          <VisibilityOffOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Hide</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default CourseMappingColumnMenu;
